import { formatDate, Location } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '@src/app/ecom-models/user';
import { EcomCartService } from '@src/app/ecom-services/ecom-cart.service';
import { EcomSettingService } from '@src/app/ecom-services/ecom-setting.service';
import { Howl } from 'howler';
import { AlertComponent } from 'ngx-bootstrap/alert';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import { ToastrService } from 'ngx-toastr';
import { EcomNetworkUtils } from 'src/app/ecom-base-entities/ecom-shared/ecom-networkutils.service';
import { ItemBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-itembase';
import { ModifierSetBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-modifersetbase';
import { ModifierSetOptionBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-modifieroptionbase';
import { VariantBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-variantbase';
import { StoreCartBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-storecartbase';
import { StoreServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-storeservicebase';
import { UserServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-userservicebase';
import { EComService } from 'src/app/ecom-services/ecom-common.service';
import { EcomValidator } from 'src/app/ecom-services/ecom-validation';
import { EComWebStorage } from 'src/app/ecom-services/ecom-webstorage.services';
import { EcomCookies } from '../../ecom-services/ecom-cookies';
import { QRType } from '@src/app/enums/qr-types.enum';
import { Discount } from '@src/app/ecom-models/discount';
import { base64decodedString } from '@src/app/ecom-gift-card/ecom-giftcard.service';
import { EcomSigninService } from '@src/app/ecom-account/ecom-signin-new/ecom-signin.service';
declare var chatWindowLoad: Function;

@Component({
  selector: 'app-ecom-status-dinein',
  templateUrl: './ecom-status-dinein.component.html',
  styleUrls: ['./ecom-status-dinein.component.scss']
})
export class EcomStatusDineinComponent implements OnInit, OnDestroy {
  // component class properties
  window: any;
  overlayDisplay = false;
  timeleft = '';
  statusCheckMessage = '';
  status = false;
  paylater = false;
  reviewandpay = false;
  locationSelected: any;
  orderlocationDetails: any;
  userServiceBase: UserServiceBase;
  userSelectedStore: StoreServiceBase;
  modalRef: BsModalRef;

  config = {
    animated: true,
    class: 'modal-dialog-centered'
  };
  serviceType: string;
  statusMessage = 'preparing you order';
  statusinput = {
    companyId: '',
    companyPkid: '',
    locationPkid: '',
    oocrs_oodcdr_pkid: '',
    oocrs_guid: '',
    OrderStatus: ''
  };
  statusWidth = '100%';
  statusWidthNumber = 5;
  percentageWidth = 5;
  orderDetails: any;
  timeoutFunc: any;
  GetStatusDisable = true;
  progressStartTime: any;
  progressEndTime: any;
  orderStatus = '';
  alerts: any[] = [{
    type: 'warning',
    msg: 'service started',
    timeout: 5000,
    isOpen: false
  }];
  autoStatusTimeOut: any;
  paymentStatus = '0';
  cashbackamount = 0;
  invoiceEmail = '';
  invoiceMsg = '';
  invoiceRequest = true;
  currency = '';
  position = 'FRONT';
  orderDatetime = '';
  LogoPath = '';
  invoiceNumber = '';
  emailForm: FormGroup;
  CompanyBusinessNumber = '';
  taxList = [];
  referForm: FormGroup;
  referMessage = '';
  referSuccess = false;
  referPhoneNumber = '';
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  selectedCountryISO: any = CountryISO.Malaysia;
  preferredCountries: CountryISO[] = [CountryISO.Malaysia, CountryISO.Australia, CountryISO.India, CountryISO.Singapore, CountryISO.Indonesia, CountryISO.Thailand];

  settings: any;
  referralDiscount: any;
  surcharges: any;
  rejectreason = '';
  discountsApplied: any;
  paymentMethod = '';
  olarPoints = 0;

  modalRefOlarmePromotion: BsModalRef;
  modalRefLoyalty: BsModalRef;
  @ViewChild('displayLoyalty', { static: true }) displayLoyalty: ElementRef;
  configloyalty = {
    animated: true,
    class: 'modal-dialog-centered modal-sm modal-loyalty-status',
    ignoreBackdropClick: false,
    keyboard: true
  };
  loayltyEarnedPoints = 0;
  loyaltyCurrentBalance = 0;
  isLoayltyMemberAlready = true;
  loyaltyEmail = "";
  loyaltyPhoneAndName = false;

  redirect = false;
  loyaltyMessage = "";
  usertoken = false;
  active = 0;
  // payatcounter popup
  modalRefPayAtCounter: BsModalRef;
  @ViewChild('displayPayAtCounter', { static: true }) displayPayAtCounter: ElementRef;

  @ViewChild('displayPoints', { static: true }) displayPoints: ElementRef;
  modalDisplayPoints: BsModalRef;
  configDisplayPoints = {
    animated: true,
    class: 'modal-dialog-centered modal-sm modal-point',
    ignoreBackdropClick: false,
    keyboard: true
  };
  configPayAtCounter = {
    animated: true,
    class: 'modal-dialog-centered modal-sm modal-payatcounter',
    ignoreBackdropClick: false,
    keyboard: true
  };
  orderInfo: any[] = [];
  orderItems: any[] = [];
  orderId = "";
  tableName: string = "";
  totalPrice: string = "";
  totalDiscount: string = "";
  subTotal: string = "";
  orders: any[] = [];

  customerHistory: any[] = [];
  serviceCharges: any[];
  intervalId: any;
  point: number = 0;
  customerLoyalty: User;
  isCustomer: boolean;
  tablePkid: number = 0;
  locationPkid: number = 0;
  companyPkid: number = 0;
  storeServiceBase: StoreServiceBase;
  // constructor to inject the class objects
  constructor(public formBuilder: FormBuilder, public router: Router,
    public ecomservice: EComService, private modalService: BsModalService,
    private toastr: ToastrService,
    public webstorage: EComWebStorage, public location: Location,
    public activatedRoute: ActivatedRoute, private cookie: EcomCookies,
    private cartService: EcomCartService,
    private settingService: EcomSettingService,
    private signinService: EcomSigninService) {
    this.userSelectedStore = new StoreServiceBase();
    this.userServiceBase = new UserServiceBase();
    this.userSelectedStore.storeCart = new StoreCartBase();

    this.settingService.currentLocationSetting.subscribe(settings => {
      this.settings = settings;
    });

    this.settingService.currentUserInfo.subscribe(value => {
      this.customerLoyalty = value;
    });
  }

  // Close loyalty Pop-up
  closeLoyalty() {
    this.modalRefLoyalty.hide();
  }

  closePoint() {
    this.modalDisplayPoints.hide();
  }



  displayPayAtCounterPopUp(display) {
    if (display) {
      this.modalRefPayAtCounter = this.modalService.show(this.displayPayAtCounter, this.configPayAtCounter);
    }
  }

  // Close loyalty Pop-up
  closePayAtCounter() {
    this.modalRefPayAtCounter.hide();
  }


  // component initialize and load the required data
  async ngOnInit() {
    const setting = this.settingService.getCompanySetting();
    if (setting) {
      this.serviceType = setting.serviceType;
    }
    this.customerHistory = [];
    this.webstorage.sessionSt_user_order_reference = undefined;

    //chatWindowLoad('block');
    this.cookie.deleteCheckoutCookies();
    if (this.webstorage.sessionSt_qr_code_scanned === undefined || this.webstorage.sessionSt_qr_code_scanned === null) {
      this.webstorage.clear('localst_userservicerequest', 'LOCAL');
    }
    else {
      let tempUserServiceBase = new UserServiceBase();
      tempUserServiceBase = this.webstorage.localSt_user_service_request;
      tempUserServiceBase.selectedStoreServiceList.forEach(element => {
        element.storeCart = new StoreCartBase();
      });
      //this.webstorage.localSt_user_service_request = tempUserServiceBase;
      this.settingService.setUserSerivce(tempUserServiceBase);
    }
    this.webstorage.sessionSt_qr_scan_current_page = this.router.url;
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });

    // alert message
    this.alerts = [];
    this.alerts.push({
      type: 'warning',
      msg: 'Refresh the browser once you receive the text message or click on the link in the message',
      timeout: 5000,
      isOpen: true
    });

    this.usertoken = (this.cookie.cookie_authtoken && this.webstorage.localSt_user_id) ? true : false;
    // if the order is not qr code order then no need to show the phone number
    if (this.webstorage.sessionSt_qrcode_type && (this.webstorage.sessionSt_qrcode_type === 'QRSTORE' || this.webstorage.sessionSt_qrcode_type === 'QRTABLE')) {

      if (!this.usertoken) {
        this.loyaltyPhoneAndName = true;

      }
    }
    this.emailForm = this.formBuilder.group({
      email: ['', Validators.compose([Validators.required, EcomValidator.emailValidator])]
    });

    await this.getMyIp();
    await this.fetchOrdersHistoryByCustomer();
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      console.log('Interval cleared');
    }
  }



  async getMyIp() {
    if (this.webstorage.localSt_ip) {
      this.LoadPage();
    } else {
      const response = await this.ecomservice.httpGetOuterResponseHeader(EcomNetworkUtils.GET_IP_ADDRESS + this.ecomservice.GetOlarConfigValue('ipgeolocation_key'), '', true).toPromise();
      if (response.status === 200) {
        this.webstorage.localSt_ip = response.body.ip;
        this.webstorage.localSt_latlng = response.body.latitude + ',' + response.body.longitude;
        this.webstorage.localSt_countrycode = response.body.country_code2;
        await this.LoadPage();
      }

    }

  }

  async LoadPage() {
    if (!this.webstorage.localSt_client_id || !this.webstorage.localSt_olar_key) {
      const url = EcomNetworkUtils.POST_GENERATEKEY;
      const response = await this.ecomservice.httpPost(url, {}, '', true).toPromise();
      if (response.isSuccess) {
        if (!this.webstorage.localSt_client_id) {
          this.webstorage.localSt_client_id = response.listValue.oock_client_id;
        }
        // store public key
        this.webstorage.localSt_olar_key = response.listValue.oock_public_key;
        await this.getOrderStatus();
      }

    } else {
      await this.getOrderStatus();
    }
  }

  // Method to get the order status
  async getOrderStatus() {
    this.activatedRoute.queryParams.subscribe(async params => {
      if (params['companyId'] && params['serviceId']) {
        this.webstorage.sessionSt_frompage = 'status';
        this.location.replaceState(this.location.path().split('?')[0], '');
        this.webstorage.sessionSt_status_companyid = params['companyId'];
        this.webstorage.sessionSt_status_serviceid = params['serviceId'];
        const lst = this.webstorage.sessionSt_status_companyids && this.webstorage.sessionSt_status_companyids.length ? this.webstorage.sessionSt_status_companyids : [];
        const model = {
          companyId: params['companyId'],
          serviceId: params['serviceId'],
          index: lst.length + 1
        }
        //const lst = this.webstorage.sessionSt_status_companyids && this.webstorage.sessionSt_status_companyids.length ? this.webstorage.sessionSt_status_companyids : [];
        lst.push(model);

        const createKey = (obj) => `${obj.companyId}-${obj.serviceId}`;

        const seen = new Set();
        const distinctArray = lst.filter(item => {
          const key = createKey(item);
          if (seen.has(key)) {
            return false;
          }
          seen.add(key);
          return true;
        }).sort((a, b) => b.index - a.index);

        this.webstorage.sessionSt_status_companyids = distinctArray;
        await this.getOrderDetails();
      }
      else {
        await this.getOrderDetails();
      }


      if (this.userServiceBase) {
        const selft = this;
        this.userServiceBase = this.webstorage.localSt_user_service_request;
        let serviceActiveId = this.webstorage.sessionSt_service_active_id;
        //this.serviceType = this.webstorage.sessionSt_service_type;
        if ((this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) || (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true)) {
          serviceActiveId = 1;
        }
        this.locationSelected = this.webstorage.sessionSt_location_selected;
        if (this.userServiceBase) {
          let userStoreIndex = -1;
          const selectedStore = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
            userStoreIndex = index;
            return obj.serviceLocationGuid === this.locationSelected.oocls_location_pkid && !obj.serviceCompleted && obj.serviceType === this.serviceType;
          });
          if (selectedStore) {
            this.tableName = selectedStore.serviceLocationTableName;
            // remove from local storage if payment is successfull
            // if it is paylater then dont remove keep it and remove after payment  
            // no need give option to pay if it's table dine in also
            /*
            *
            *
            *  
            if (this.webstorage.sessionSt_dinein_paylater) {
              this.paylater = this.webstorage.sessionSt_dinein_paylater;
            }
            if (!this.paylater) {
              this.userServiceBase.selectedStoreServiceList.splice(userStoreIndex, 1);
            }
            */
            // if it qr code order don't remove from local storage in order to get back his cart

            if ((this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) || (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true)) {
              this.webstorage.sessionSt_service_active_id = 1;
              this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart = new StoreCartBase();
              this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderItems = [];
            } else {
              this.userServiceBase.selectedStoreServiceList.splice(userStoreIndex, 1);
            }
          }
          this.webstorage.localSt_user_service_request = this.userServiceBase;
          // after payment success clear the active id from session
          this.webstorage.clear('sessionst_serviceactiveid', 'SESSION');
        }
      }

      await this.fetchOrdersHistoryByCustomer();
    });
  }

  async fetchUserByPkid(model: any) {
    const res = await this.signinService.fetchUserByPkid(model).toPromise();
    if (res.isSuccess && res.listValue) {
      const data = res.listValue;

      this.settingService.setUserInfo(new User({
        userPkid: data.customer_pkid,
        firstName: data.customer_first_name,
        companyPkid: data.customer_company_pkid,
        locationPkid: data.customer_location_pkid,
        phoneNumber: data.customer_phone_number,
        dialCode: data.customer_country_dial_code
      }));

    }
  }

  // Method to get the order details
  async getOrderDetails() {
    if (this.webstorage.sessionSt_status_companyids) {

      const lst = this.webstorage.sessionSt_status_companyids;
      let index = 0;
      for (const element of lst) {
        await this.fetchDetails(element.companyId, element.serviceId, index);
        index++;
      }

      if (this.orders && this.orders.length) {
        let order = this.orders[0];
        this.tablePkid = Number(order.orderInfo.tableId);
        this.locationPkid = Number(order.orderInfo.location_pkid);
        this.companyPkid = Number(order.orderInfo.company_pkid);
        this.statusinput.OrderStatus = order.orderStatus;
        const userService = this.settingService.getUserSerivce();
        const point = order.orderInfo.gained_points;
        if (point > 0) {
          this.point = point;
          this.isCustomer = !!order.orderInfo.customer_pkid;
          userService.lastOrderPkid = +order.serviceId;
          this.modalDisplayPoints = this.modalService.show(this.displayPoints, this.configDisplayPoints);
        }

        if (order.orderStatus === 'DRAFT') {
          userService.hasUnpaidOrder = !order.paid;

          this.setProgressBarPercentage(1, '1%');
          this.displayPayAtCounterPopUp(
            !order.paid &&
            order.orderStatus === 'DRAFT' &&
            order.orderInfo.order_acceptance_unpaid === 'M' &&
            order.orderInfo.payment_serve_type === 'A'
          );

          // Check and recall fetchDetails if 'DRAFT'
          this.intervalId = setInterval(async () => {
            if (this.orders && this.orders.length) order = this.orders[0];
            if (order.orderStatus !== 'DRAFT') {
              clearInterval(this.intervalId);
            } else {
              console.log(`${order.orderId} has not been accepted yet. Retrying in 10 seconds...`);
              await this.fetchDetails(order.company_id, order.serviceId, 0, false);
            }
          }, 10000);

        }

        if (order.paid) {
          this.settingService.setDiscounts([]);
        }
        this.settingService.setUserSerivce(userService);
      }
      else {
        this.webstorage.sessionSt_status_companyids = null;
        await this.onBackClick();
      }


      return;
    }


    this.orderDetails = undefined;
    if (this.webstorage.sessionSt_status_companyid === null) {
      //this.router.navigate(['home']);
    } else {
      // get status from db
      const companyId = this.webstorage.sessionSt_status_companyid;
      const serviceGuid = this.webstorage.sessionSt_status_serviceid;
      const url = EcomNetworkUtils.GET_DINEIN_COLLECTION_DELIVERY_STATUS + '?companyId=' + companyId + '&serviceId=' + serviceGuid;
      this.ecomservice.httpGet(url, '', true).subscribe(response => {

        if (response['status'] === 403) {
          this.router.navigate(['unauthorized']);
          return;
        }
        if (response.isSuccess) {

          this.orderInfo = response.listValue;
          this.orderId = response.listValue.sos_order_id;
          // to display the pay at counter popup
          let companyFound = true
          // this.company_guid_array.find(obj => {
          //   return obj.toUpperCase() === response.listValue.oodcdr_company_guid.toUpperCase();
          // });
          console.log(companyFound);
          // if (companyFound && response.listValue.order_payment_method === 'CASH') {
          //   this.displayPayAtCounterPopUp(true);
          // }
          // this.getMerchantCustomerLoyaltyDetails(companyId, response.listValue.UserMobile, response.listValue.UserDialCode, response['listValue']['sales_orders']['sales_order_guid']);
          // this.olarPoints = response.listValue.order_olar_points_earned;
          // if (this.olarPoints > 0) {
          //   this.OlarmePromotion();
          // }
          this.statusinput.OrderStatus = response.listValue.status;
          if (this.statusinput.OrderStatus === 'DRAFT') this.setProgressBarPercentage(50, '50%');
          this.updateStatusMessage(this.statusinput.OrderStatus);
          this.calculateTotal(this.orderInfo);


        }

      });
    }
  }

  async fetchDetails(company_id: string, serviceId: string, index: number, loading = true) {
    const url = `${EcomNetworkUtils.GET_DINEIN_COLLECTION_DELIVERY_STATUS}?companyId=${company_id}&serviceId=${serviceId}`;
    const response = await this.ecomservice.httpGet(url, '', loading).toPromise();

    if (response['status'] === 403) {
      this.router.navigate(['unauthorized']);
      return response;
    }
    if (response.isSuccess) {

      const res = {
        company_id,
        serviceId,
        orderInfo: response.listValue,
        orderId: response.listValue.sos_order_id,
        orderStatus: response.listValue.status,
        paid: response.listValue.paid,
        table: response.listValue.table,
        type: response.listValue.type
      }

      if (!this.settings) {

        const param = {
          oocls_location_pkid: response.listValue.location_pkid,
          oocls_company_id: company_id,
          companyPkid: response.listValue.company_pkid
        }
        const responseSetting = await this.ecomservice.httpPost(EcomNetworkUtils.POST_GET_LOCATIONS_SETTINGS, param, '', true).toPromise();
        if (responseSetting.isSuccess) {
          const locationSettingData = responseSetting.listValue;
          this.settings = locationSettingData;
          this.settingService.setLocationSetting(locationSettingData);

        }
      }


      const order = this.calculateTotal(res);
      if (order) {
        const existingIndex = this.orders.findIndex(o => o.orderId === order.orderId);
        // If the order already exists in the list
        if (existingIndex !== -1) {
          // Replace the existing order with the new one
          this.orders[existingIndex] = order;
        } else {
          this.orders.push(order);
        }
      }
      this.statusinput.OrderStatus = response.listValue.status;
      this.statusinput.companyPkid = response.listValue.company_pkid;
      this.statusinput.companyId = company_id;
      this.statusinput.locationPkid = response.listValue.location_pkid;
      this.statusinput.oocrs_oodcdr_pkid = serviceId;

      if (this.statusinput.OrderStatus === 'OPEN') {
        this.statusWidth = "100%";
      }
    }

    return response;
  }

  async fetchOrdersHistoryByCustomer() {
    this.customerHistory = [];
    const user = this.settingService.getUserInfo();
    const setting = this.settingService.getCompanySetting();

    if (!user || !user.userPkid) return;

    const model = {
      customerPkid: user.userPkid,
      companyPkid: setting.oocls_company_pkid
    }
    const response = await this.ecomservice.httpPost(EcomNetworkUtils.GET_CUTOMER_ORDER_HISTORY, model, '', false).toPromise();

    if (response['status'] === 403) {
      this.router.navigate(['unauthorized']);
      return response;
    }
    if (response.isSuccess && response.listValues) {

      const excludeIds = this.orders.map(x => Number(x.serviceId));
      const lst = response.listValues.filter(x => !excludeIds.includes(x.oodcdr_pkid));

      lst.forEach(order => {
        
        const obj = {
          //company_id: "test xelo ex",
          is_completed: order.is_completed,
          company_pkid: order.company_pkid,
          oodcdr_pkid: order.oodcdr_pkid,
          date: formatDate(order.updated_at, 'dd-MM-yyyy HH:mm', 'en-US'),
          serviceId: order.oodcdr_pkid,
          orderId: order.sos_order_id.includes("OLA") ? "OLA" + order.sos_order_id.split("OLA")[1] : "",
          orderStatus: order.status,
          paid: order.paid,
          table: order.table,
          type: order.type,
          totalEntireDiscounts: 0,
          totalDiscount: 0,
          totalPrice: order.sos_net_total_amount.toFixed(2)
        };

        if (!this.customerHistory.some(item => item.oodcdr_pkid === obj.oodcdr_pkid)) {
          this.customerHistory.push(obj);
        }
      })


    }

  }

  async seeDetails(item, index: number) {

    const model = {
      company_pkid: item.company_pkid,
      oodcdr_pkid: item.oodcdr_pkid
    };
    const response = await this.ecomservice.httpPost(EcomNetworkUtils.GET_CUTOMER_ORDER_DETAIL, model, '', true).toPromise();
    if (response.isSuccess && response.listValue) {
      const itemData = response.listValue;
      const res = {
        company_id: itemData.company_id,
        //serviceId,
        orderInfo: itemData,
        orderId: itemData.sos_order_id,
        orderStatus: itemData.status,
        paid: itemData.paid,
        table: itemData.table,
        type: itemData.type,
        date: formatDate(itemData.updated_at, 'dd-MM-yyyy HH:mm', 'en-US'),
        is_completed: itemData.is_completed,
        roundoff_amount: 0,
        loyalty_discount: itemData.loyalty_discount
      } as any;

      // if (!this.settings) {

      //   const param = {
      //     oocls_location_pkid: response.listValue.location_pkid,
      //     oocls_company_id: "",
      //     companyPkid: response.listValue.company_pkid
      //   }
      //   const responseSetting = await this.ecomservice.httpPost(EcomNetworkUtils.POST_GET_LOCATIONS_SETTINGS, param, '', true).toPromise();
      //   if (responseSetting.isSuccess) {
      //     const locationSettingData = responseSetting.listValue;
      //     this.settings = locationSettingData;
      //     this.settingService.setLocationSetting(locationSettingData);

      //   }
      // }

      if (!res.is_completed) {
        const order = this.calculateTotal(res);
        if (order) {
          // Replace the existing order with the new one
          this.customerHistory[index] = order;
        }
      } else {

        res.serviceCharges = itemData.surcharges.map(x => ({
          amountSurcharge: x.surcharge_amount,
          surchargeName: x.surcharge_name
        }));

        let loyaltyDiscountAmount = 0;
        if (res.loyalty_discount && res.loyalty_discount.paid_amount > 0) {
          loyaltyDiscountAmount = res.loyalty_discount.paid_amount;
        }

        res.taxs = itemData.taxes;
        res.subTotal = itemData.sub_total.toFixed(2);
        res.totalDiscount = 0;
        res.loyaltyDiscount = loyaltyDiscountAmount;
        res.totalPrice = (itemData.sos_net_total_amount - loyaltyDiscountAmount).toFixed(2);
        res.roundoff_amount = itemData.roundoff_amount;
        this.customerHistory[index] = res;
      }



    }
  }

  calculateTotal(orderItem) {
    if (!orderItem.orderInfo.items.length || !this.settings) return;

    let totalPrice = 0;
    let totalDiscount = 0;
    const taxType = this.settings.company_sell_price_tax;
    let itemTaxs = {};
    let priceBeforeDiscount = 0;
    let taxs = [];

    orderItem.orderInfo.items.forEach(item => {
      //const taxEach = this.calculateTax(taxType, item.price, item.tax_rate);
      //check item has discount
      let discountedAmount = 0;
      let discountType = "AMOUNT";
      if (item.discounts) {
        discountedAmount = item.discounts.discount_type === "AMOUNT" ? item.discounts.price : item.discounts.percentage;
        if (item.discounts.discount_type) {
          discountType = item.discounts.discount_type;
        }
      }

      if (item.reward) {
        discountedAmount = item.reward.discount_type === "AMOUNT" ? item.reward.price : item.reward.percentage;
        if (item.reward.discount_type) {
          discountType = item.reward.discount_type;
        }
      }

      const tax = this.calculatePrice(item.quantity * item.price, item.tax_rate, discountedAmount, taxType, discountType);
      if (item.discounts && item.discounts.discount_source === "MANUAL") {
        item.discounts.price = tax.discountAmount;
        item.discounts.discount_source = "AUTO";
      }


      taxs.push({ tax_pkid: item.tax_pkid, tax_name: item.tax_name, tax_amount: tax.taxAmount });
      let totalModifiersPrice = 0;
      if (item.modifiers && item.modifiers.length > 0) {
        item.modifiers.forEach(modItem => {

          const tax = this.calculatePrice(item.quantity * modItem.modifier_option_price, modItem.tax_rate, 0, taxType, "AMOUNT");

          taxs.push({ tax_pkid: modItem.tax_pkid, tax_name: modItem.tax_name, tax_amount: tax.taxAmount });
          totalModifiersPrice += item.quantity * modItem.modifier_option_price;
        })
      }

      //const totalModifiersPrice = item.modifiers.length ? (item.quantity * item.modifiers.reduce((total, modifier) => total + modifier.modifier_option_price, 0)) : 0;
      totalPrice += item.price * item.quantity + totalModifiersPrice;
      //totalDiscount += item.discounts && item.discounts.price ? item.discounts.price : 0;
      totalDiscount +=
        (item.discounts && item.discounts.price ? item.discounts.price : 0) +
        (item.reward && item.reward.price ? item.reward.price : 0);
      priceBeforeDiscount += item.price * item.quantity + totalModifiersPrice;
      let res = this.cartService.calculateTax("TAX_IN", item.price - (item.discounts ? item.discounts.price : 0), item.tax_rate);
    });

    // Other lv dicount
    let entireDiscounts = 0;
    orderItem.totalEntireDiscounts = 0;
    if (orderItem.orderInfo.order_level_discount) {

      const { discount_minimum_requirement, max_value, discount_value_type, discount_value } = orderItem.orderInfo.order_level_discount;
      // Minimum Requirement
      // Quanity

      if (discount_minimum_requirement === 'QUANTITY') {
        taxs = [];
        const { newTotalPrice, itemTaxObj, discountedAmount, taxsList } = this.calculateEntireDiscount(discount_value_type, priceBeforeDiscount - totalDiscount, discount_value, orderItem.orderInfo.items, max_value);
        //totalPrice = newTotalPrice;
        itemTaxs = itemTaxObj;
        entireDiscounts = discountedAmount;
        taxs.push(...taxsList)
      }
      // Amount
      else if (discount_minimum_requirement === 'AMOUNT') {
        taxs = [];
        const { newTotalPrice, itemTaxObj, discountedAmount, taxsList } = this.calculateEntireDiscount(discount_value_type, priceBeforeDiscount - totalDiscount, discount_value, orderItem.orderInfo.items, max_value);
        //totalPrice = newTotalPrice;
        itemTaxs = itemTaxObj;
        entireDiscounts = discountedAmount;
        taxs.push(...taxsList)
      }
      //None
      else if (discount_minimum_requirement === 'NONE') {
        taxs = [];
        const { newTotalPrice, itemTaxObj, discountedAmount, taxsList } = this.calculateEntireDiscount(discount_value_type, priceBeforeDiscount - totalDiscount, discount_value, orderItem.orderInfo.items, max_value);
        // totalPrice = newTotalPrice;
        itemTaxs = itemTaxObj;
        taxs.push(...taxsList)
        entireDiscounts = discountedAmount;
      }

    }

    if (orderItem.orderInfo.order_level_reward) {

      const { discount_minimum_requirement, max_value, discount_value_type, discount_value } = orderItem.orderInfo.order_level_reward;
      // Minimum Requirement
      // Quanity

      if (discount_minimum_requirement === 'QUANTITY') {
        taxs = [];
        const { newTotalPrice, itemTaxObj, discountedAmount, taxsList } = this.calculateEntireDiscount(discount_value_type, priceBeforeDiscount - totalDiscount, discount_value, orderItem.orderInfo.items, max_value);
        //totalPrice = newTotalPrice;
        itemTaxs = itemTaxObj;
        entireDiscounts = discountedAmount;
        taxs.push(...taxsList)
      }
      // Amount
      else if (discount_minimum_requirement === 'AMOUNT') {
        taxs = [];
        const { newTotalPrice, itemTaxObj, discountedAmount, taxsList } = this.calculateEntireDiscount(discount_value_type, priceBeforeDiscount - totalDiscount, discount_value, orderItem.orderInfo.items, max_value);
        //totalPrice = newTotalPrice;
        itemTaxs = itemTaxObj;
        entireDiscounts = discountedAmount;
        taxs.push(...taxsList)
      }
      //None
      else if (discount_minimum_requirement === 'NONE') {
        taxs = [];
        const { newTotalPrice, itemTaxObj, discountedAmount, taxsList } = this.calculateEntireDiscount(discount_value_type, priceBeforeDiscount - totalDiscount, discount_value, orderItem.orderInfo.items, max_value);
        // totalPrice = newTotalPrice;
        itemTaxs = itemTaxObj;
        taxs.push(...taxsList)
        entireDiscounts = discountedAmount;
      }

    }

    orderItem.serviceCharges = [];

    if (orderItem.orderInfo.surcharges.length > 0) {
      let totalSurcharge = 0;
      let totalSurchargeTax = 0;
      let surchargeAmt = 0;
      let surchargeTax = 0;
      //let priceBeforeDiscount = 0;
      //console.log('surcharges:', surcharges);
      //if (!priceBeforeDiscount) return;

      orderItem.orderInfo.surcharges.forEach(sur => {
        let obj: any;
        //After discount
        if (sur.surcharge_discount === "A") {
          if (taxType !== "TAX_EX") {
            surchargeAmt = (sur.surcharge_percentage / 100) * (priceBeforeDiscount);

            if (sur.tax_rate > 0) {

              surchargeTax = (sur.tax_rate / 100) * surchargeAmt;
              itemTaxs = this.addTax(itemTaxs, { tax_pkid: sur.tax_pkid, tax_name: sur.tax_name }, surchargeTax);
            }
            obj = {
              amountSurcharge: surchargeAmt,
              surchargeName: `${sur.surcharge_name} (${sur.surcharge_percentage}%)`,
              //surchargeTax
            }
          } else {
            const surchargeAmt = (sur.surcharge_percentage / 100) * (priceBeforeDiscount - totalDiscount - entireDiscounts);
            if (sur.tax_rate > 0) {

              const surchargeTax = (sur.tax_rate / 100) * surchargeAmt;
              taxs.push({ tax_pkid: sur.tax_pkid, tax_name: sur.tax_name, tax_amount: surchargeTax });
            }
            obj = {
              amountSurcharge: surchargeAmt,
              surchargeName: `${sur.surcharge_name} (${sur.surcharge_percentage}%)`,
              //surchargeTax
            }
          }
          //totalSurcharge += surchargeAmt;
          //console.log("why", this.totalSurcharge)
          //this.totalSurchargeTax += surchargeTax;
        }
        //Before discount
        else {
          if (taxType === "TAX_IN") {
            surchargeAmt = (sur.surcharge_percentage / 100) * priceBeforeDiscount;
            if (sur.tax_rate) {
              const rate = sur.tax_rate / 100;
              surchargeTax = (surchargeAmt / (1 + rate)) * rate;
              //itemTaxs = this.addTax(itemTaxs, { tax_pkid: sur.tax_pkid, tax_name: sur.tax_name }, surchargeTax);
              taxs.push({ tax_pkid: sur.tax_pkid, tax_name: sur.tax_name, tax_amount: surchargeTax });
            }
            obj = {
              amountSurcharge: surchargeAmt,
              surchargeName: `${sur.surcharge_name} (${sur.surcharge_percentage}%)`,
              //surchargeTax
            }
          } else {
            //const aa = this.subTotal
            surchargeAmt = (sur.surcharge_percentage / 100) * priceBeforeDiscount;

            if (sur.tax_rate) {
              surchargeTax = (sur.tax_rate / 100) * surchargeAmt;
              //itemTaxs = this.addTax(itemTaxs, { tax_pkid: sur.tax_pkid, tax_name: sur.tax_name }, surchargeTax);
              taxs.push({ tax_pkid: sur.tax_pkid, tax_name: sur.tax_name, tax_amount: surchargeTax });
            }
            obj = {
              amountSurcharge: surchargeAmt,
              surchargeName: `${sur.surcharge_name} (${sur.surcharge_percentage}%)`,
              //surchargeTax
            }
          }
        }
        totalSurcharge += obj.amountSurcharge;
        totalSurchargeTax += obj.surchargeTax;

        orderItem.serviceCharges.push(obj);
      });



      // this.subTotal = totalPrice;
      // this.totalDiscount = totalDiscount;
      // this.totalEntireDiscounts = entireDiscounts;
      // this.totalTax = taxAmount + modTax;
      // this.total = this.subTotal - this.totalDiscount - this.totalEntireDiscounts + totalSurcharge + totalSurchargeTax;
      // if (taxType === "TAX_EX") this.total = this.total + this.totalTax;

      // cart.storeCart.orderTotal = this.total;
    }
    let loyaltyDiscountAmount = 0;
    if (orderItem.orderInfo.loyalty_discount && orderItem.orderInfo.loyalty_discount.paid_amount > 0) {
      loyaltyDiscountAmount = orderItem.orderInfo.loyalty_discount.paid_amount;
    }

    const totalSurcharge = orderItem.serviceCharges.reduce((total, r) => total + r.amountSurcharge, 0);
    const totalTax = taxs.filter(x => x.tax_amount).reduce((total, t) => total + t.tax_amount, 0);
    orderItem.totalEntireDiscounts = entireDiscounts;
    orderItem.taxs = this.mergeTaxes(taxs);
    orderItem.subTotal = totalPrice.toFixed(2);
    orderItem.totalDiscount = totalDiscount;
    orderItem.loyaltyDiscount = loyaltyDiscountAmount;

    let total = totalPrice - totalDiscount - entireDiscounts - loyaltyDiscountAmount + totalSurcharge;
    if (taxType === "TAX_EX") {
      total = total + totalTax;
    }
    orderItem.totalPrice = total.toFixed(2);
    return orderItem;
  }
  joinNow() {
    this.modalDisplayPoints.hide();
    this.router.navigate(['signin']);
  }
  mergeTaxes(taxs) {
    return taxs.reduce((acc, item) => {
      let existingTax = acc.find(tax => tax.tax_pkid === item.tax_pkid);
      if (existingTax) {
        existingTax.tax_amount += item.tax_amount;
      } else {
        acc.push({ tax_pkid: item.tax_pkid, tax_name: item.tax_name, tax_amount: item.tax_amount });
      }
      return acc;
    }, []);
  }

  calculateTax(type: string, price: number, taxRate: number) {
    let taxAmount = 0;
    if (type === 'TAX_IN') {

      const actualPrice = price / (1 + taxRate / 100);
      taxAmount = price - actualPrice;
    } else {
      taxAmount = (taxRate / 100) * price;
    }
    return Number(taxAmount.toFixed(4));
  }
  calculatePrice(
    price,
    taxRatePercent,
    discountRatePercentOrAmount,
    taxType,
    discountType,
    max_value = 0
  ) {
    //taxType = "TAX_IN";
    // Chuyển đổi từ phần trăm sang thập phân
    let taxRate = taxRatePercent / 100;

    let priceAfterDiscount, discountAmount, taxAmount, finalPrice, priceBeforeTax;

    if (taxType === "TAX_IN") {
      // Nếu giá đã bao gồm thuế
      // Tính giá trước thuế
      priceBeforeTax = price / (1 + taxRate);

      if (discountType === "AMOUNT") {
        // Nếu giảm giá là một số tiền cụ thể
        discountAmount = discountRatePercentOrAmount;
        const taxFactor = discountRatePercentOrAmount / price;
        priceAfterDiscount = priceBeforeTax * (1 - taxFactor);
        const originalTaxAmount = priceBeforeTax * taxRate;
        taxAmount = originalTaxAmount * (1 - taxFactor);
        finalPrice = price - discountAmount;
        return {
          priceAfterDiscount,
          discountAmount,
          taxAmount,
          finalPrice,
          price,
          priceBeforeTax
        };
      } if (discountType === "PERCENTAGE") {
        // Nếu giảm giá là tỷ lệ phần trăm
        const discountRate = discountRatePercentOrAmount / 100;
        discountAmount = price * discountRate;
        priceAfterDiscount = price - discountAmount;
        taxAmount = (priceAfterDiscount / (1 + taxRate)) * taxRate;
        return {
          priceAfterDiscount,
          discountAmount,
          taxAmount,
          finalPrice,
          price,
          priceBeforeTax
        };
      }
      if (discountType === "FIXED_AMOUNT") {
        discountRatePercentOrAmount = price - discountRatePercentOrAmount;
        discountAmount = discountRatePercentOrAmount;
        const taxFactor = discountRatePercentOrAmount / price;
        priceAfterDiscount = priceBeforeTax * (1 - taxFactor);
        const originalTaxAmount = priceBeforeTax * taxRate;
        taxAmount = originalTaxAmount * (1 - taxFactor);
        finalPrice = price - discountAmount;
        return {
          priceAfterDiscount,
          discountAmount,
          taxAmount,
          finalPrice,
          price,
          priceBeforeTax
        };
      }

      // Tính giá sau giảm giá nhưng trước thuế
      priceAfterDiscount = price - discountAmount;

      // Tính số thuế trên giá đã giảm
      taxAmount = priceAfterDiscount * taxRate;

      // Tính tổng số tiền phải trả
      finalPrice = priceAfterDiscount + taxAmount;

      // Recalute discountAmount
      //discountAmount = price * discountRate;

    } else {
      // Nếu giá chưa bao gồm thuế
      if (discountType === "AMOUNT") {
        // Nếu giảm giá là một số tiền cụ thể
        discountAmount = discountRatePercentOrAmount;
      } if (discountType === "PERCENTAGE") {
        // Nếu giảm giá là tỷ lệ phần trăm
        const discountRate = discountRatePercentOrAmount / 100;
        discountAmount = price * discountRate;
      }
      if (discountType === "FIXED_AMOUNT") {
        discountAmount = price - discountRatePercentOrAmount;
      }

      if (max_value) {
        discountAmount = Math.min(discountAmount, max_value);
      }

      // Tính giá sau giảm giá
      priceAfterDiscount = price - discountAmount;

      // Tính số thuế trên giá đã giảm
      taxAmount = priceAfterDiscount * taxRate;

      // Tính tổng số tiền phải trả
      finalPrice = priceAfterDiscount + taxAmount;
    }

    return {
      priceAfterDiscount,
      discountAmount,
      taxAmount,
      finalPrice,
      price,
      priceBeforeTax
    };
  }


  calculateEntireDiscount(type: string, total: number, value: number, lst, max_value = 0) {
    const taxType = this.settings.company_sell_price_tax;
    let discountedAmount = 0;
    let discountPercent = 0;
    if (type === 'PERCENTAGE') {
      discountedAmount = (total * (value / 100));
      discountPercent = value
    } else if (type === 'AMOUNT') {
      discountPercent = (Math.min(value, total) / total) * 100;
      //discountedAmount = (total * (discountPercent / 100));
    }

    let totalPrice = 0;
    //const entireDiscount = discountedAmount;
    let totalDiscount = 0;
    let taxAmount = 0;
    let itemTaxObj = {};
    const taxs: any = [];
    lst.forEach((item) => {

      let price = item.quantity * item.price - (item.discounts && item.discounts.price ? item.discounts.price : 0);
      if (item.reward && item.reward.price) {
        price = item.quantity * item.price - item.reward.price;
      }
      const res = this.calculatePrice(price, item.tax_rate, discountPercent, taxType, "PERCENTAGE", max_value);
      //const res = this.cartService.calculatePrice(item.quantity * item.priceEach - item.discountAmount, item.tax.tax_rate, discountPercent, taxType, "PERCENTAGE");
      totalPrice += res.price;
      totalDiscount += res.discountAmount;
      //console.log("discountAmount", res.discountAmount);

      taxAmount = res.taxAmount;

      //itemTaxObj = this.addTax(itemTaxObj, item.tax, taxAmount);
      taxs.push({ tax_pkid: item.tax_pkid, tax_name: item.tax_name, tax_amount: res.taxAmount });
      // Modifiers
      let modTax = 0;

      if (item.modifiers && item.modifiers.length > 0) {
        item.modifiers.forEach((modItem: any) => {
          const res = this.calculatePrice(item.quantity * modItem.modifier_option_price, modItem.tax_rate, discountPercent, taxType, "PERCENTAGE", max_value);
          //const res = this.cartService.calculatePrice(item.quantity * modItem.modifier_option_price, modItem.tax.tax_rate, discountPercent, taxType, "PERCENTAGE");
          totalPrice += res.price;
          totalDiscount += res.discountAmount;

          taxs.push({ tax_pkid: modItem.tax_pkid, tax_name: modItem.tax_name, tax_amount: res.taxAmount });
        });
      }


    });

    return {
      newTotalPrice: totalPrice,
      itemTaxObj,
      discountedAmount: totalDiscount,
      taxsList: taxs
    }

  }


  addTax(itemTaxObj, tax, taxAmount) {
    if (!itemTaxObj[tax.tax_pkid]) {
      itemTaxObj[tax.tax_pkid] = { total: 0, taxName: tax.tax_name };
    }

    // Cộng giá vào tổng
    itemTaxObj[tax.tax_pkid].total += taxAmount;

    return itemTaxObj;
  }



  async onBackClick() {
    const currentURL = this.webstorage.sessionSt_serviceid;
    let tableId = 0;
    let locationId = 0;
    let companyId = 0;
    let userPKid = 0;
    if (currentURL) {
      const queryParams = new URL(currentURL);
      tableId = Number(queryParams.searchParams.get("T"));
      locationId = Number(queryParams.searchParams.get("L"));
      companyId = Number(queryParams.searchParams.get("C"));
      const userId = base64decodedString(queryParams.searchParams.get("U"));
      const numValue = Number(userId);
      userPKid = isNaN(numValue) ? 0 : numValue;
    }
    else {
      tableId = Number(this.tablePkid);
      locationId = Number(this.locationPkid);
      companyId = Number(this.companyPkid);
    }



    this.webstorage.sessionSt_status_serviceid = null;

    if (tableId) {
      this.settingService.setQRCodeType(QRType.Table);
      await this.fetchBasicSettings(tableId, 0, 0);
    } // LOCATION
    else if (locationId && companyId) {
      this.settingService.setQRCodeType(QRType.Store);
      await this.fetchBasicSettings(tableId, locationId, companyId);
    }

    if (userPKid) {


      const companySetting = this.settingService.getCompanySetting();

      if (companySetting) {
        const model = {
          UserPkid: userPKid,
          CompanyPkid: companySetting.oocls_company_pkid,
          CompanyId: companySetting.oocls_company_id
        }
        await this.fetchUserByPkid(model);
      }

    }
    this.settingService.setDiscounts([]);
    this.router.navigate(['items', "ordering"]);
  }

  async addMoreItem(data) {
    this.webstorage.sessionSt_status_serviceid = data.serviceId;
    const tableId = Number(data.orderInfo.tableId);
    const locationPkid = data.orderInfo.location_pkid;
    const companyPkid = data.orderInfo.company_pkid;

    let type = QRType.Table;
    if (tableId) {
      type = QRType.Table;
    } else if (locationPkid && companyPkid) {
      type = QRType.Store;
    }
    this.settingService.setQRCodeType(type);
    await this.fetchBasicSettings(tableId, locationPkid, companyPkid);
    this.router.navigate(['items', "ordering"]);
  }

  async repeat(data) {
    this.webstorage.sessionSt_status_serviceid = null;
    const items = data.orderInfo.items
    //.filter(x => x.item_pkid === 1133);
    console.log(items);

    items.forEach(async item => {

      const model = {
        companyId: data.company_id,
        locationPkid: data.orderInfo.location_pkid,
        itemPkid: item.item_pkid,
        orderDateTime: Date.now(),
        variantId: item.variant_pkid
      };
      debugger
      const modIds = item.modifiers.map(x => x.modifier_option_pkid);
      const res = await this.fetchItemDetails(model, item.quantity);
      this.setDefaults2(res, item.quantity, modIds);
      //this.mapDiscounts(res);
      console.log(res);
      this.cartService.updateCart(res, data.orderInfo.location_pkid);
    })

    this.router.navigate(['cart', 'review']);
  }



  async fetchItemDetails(model, quantity) {
    try {
      //this.ecomservice.loadingPage.loading = true;

      const response = await this.ecomservice.httpPost(
        `${EcomNetworkUtils.GET_ITEM_DETAILS}`,
        model, '', false
      ).toPromise();

      //this.ecomservice.loadingPage.loading = false;

      if (response.status === 200) {
        const itemDetails = response.listValue;

        if (!itemDetails) {

          return null;
        }
        //return itemDetails;
        return this.mapItemBase(itemDetails, quantity);
      }

      return null; // Trả về null nếu không có item
    } catch (error) {
      this.ecomservice.loadingPage.loading = false;
      console.error('Error fetching item details:', error);
    }
  }

  mapItemBase(item, quantity) {
    const itemDetails = new ItemBase({
      earning_points: item.mm_items_standard_composite_variant_service_details.length > 0 && item.mm_items_standard_composite_variant_service_details[0].earning_points,
      has_benefit_count: item.mm_items_standard_composite_variant_service_details.length > 0 && item.mm_items_standard_composite_variant_service_details[0].has_benefit_count,
      itemGuid: item.item_pkid,
      itemName: item.item_name,
      itemAlternativeName: item.item_alternative_name,
      itemDescription: item.item_description,
      imagePath: item.item_image,
      imageColor: item.item_color,
      isValid: true,
      HasModifier: item.HasModifiers,
      has_discount: item.iscvsd_has_discount,
      iscvsd_pkid: item.iscvsd_pkid
    });

    if (item.HasModifiers) {
      itemDetails.itemModId = `${item.item_pkid}-${item.iscvsd_pkid}`;
    }

    itemDetails.discounts = item.discounts && item.discounts.map(x => new Discount(x));


    const taxtype = this.settings.company_sell_price_tax;

    const tax = item.mm_items_standard_composite_variant_service_details.length > 0 && item.mm_items_standard_composite_variant_service_details[0].mm_taxes;
    if (tax) {
      itemDetails.tax = tax;
    }
    // variants
    item.mm_items_standard_composite_variant_service_details.forEach(element => {
      const taxRate = element.mm_taxes.tax_rate;
      let dineInPrice = element.online_order_item_pricing.ooip_price_value;
      let deliveryCollectionPrice = element.online_order_item_pricing.ooip_price_value;
      let dineInPriceDiscounted = element.online_order_item_pricing.ooip_dinein_discount_price_value;
      let collectionPriceDiscounted = element.online_order_item_pricing.ooip_collection_delivery_discount_price_value;

      const variant = new VariantBase({
        variant_oadp: element.online_order_item_pricing.ooip_oadp,
        variantGuid: element.iscvsd_pkid,
        variantName: element.iscvsd_name,
        variantAlternativeName: element.iscvsd_alternative_name,
        variantDineInPrice: Number(Number(dineInPrice).toFixed(2)),
        variantDeliveryCollectionPrice: Number(Number(deliveryCollectionPrice).toFixed(2)),
        variantDineInPriceDiscounted: Number(Number(dineInPriceDiscounted).toFixed(2)),
        variantCollectionPriceDiscounted: Number(Number(collectionPriceDiscounted).toFixed(2)),
        variantMaxPerOrder: element.online_order_item_pricing.ooip_max_per_order,
        variantMaxPerDay: element.online_order_item_pricing.ooip_max_per_day,
        selected: false,
        variantTaxGuid: element.mm_taxes.tax_guid,
        variantTaxRate: taxRate,
        variantAvailable: element.online_order_item_pricing.ooip_is_active && element.online_order_item_pricing.availableForSelctedDateTime,
        variantSKU: element.iscvsd_sku,
        outofstock: element.outofstock
      });
      itemDetails.variantList.push(variant);
    });
    // modifiers    
    item.mm_items_modifier_mappings.forEach(element => {

      const modifier = new ModifierSetBase({
        modifiermappingGuid: element.imm_guid,
        modifierGuid: element.imm_modifier_guid,
        modifierName: element.modifier_name,
        modifierCaption: element.modifier_caption,
        modifierSetMin: element.imm_modifier_minimum,
        modifierSetMax: element.imm_modifier_maximum,
        modifierOptions: [],
        collapsed: false,
        quantity: 0,
      });

      //modifier.selectedOptions = [];
      const modifierOptions = [];
      element.mm_items_modifier_mapping_options.forEach(option => {
        let modifierOptionPrice = option.mm_items_modifier_options.modifier_option_price;
        const modifierTaxRate = option.mm_items_modifier_options.mm_taxes.tax_rate;

        let modifierTax = 0;

        let optionData = this.ModifierSetOptionMapData(option, modifierTaxRate, modifierTax, modifier, taxtype);

        if (option.mm_items_modifier_options.modifiers_into_modifier.length) {

          const modifiers_into_modifier = option.mm_items_modifier_options.modifiers_into_modifier.map(x => this.ModifierSetOptionMapData(x, modifierTaxRate, modifierTax, modifier, taxtype, true));
          optionData = { ...optionData, modifiers_into_modifier: modifiers_into_modifier }
        }
        modifierOptions.push(optionData);
      });
      // sort by price
      //modifierOptions.sort((a, b) => a.optionPrice < b.optionPrice ? -1 : a.optionPrice > b.optionPrice ? 1 : 0);
      modifier.modifierOptions = modifierOptions;
      itemDetails.modifierSetList.push(modifier);
    });
    //this.setDefaults();
    this.setDefaults2(itemDetails, quantity);
    return itemDetails;
  }

  ModifierSetOptionMapData(option, modifierTaxRate, modifierTax, modifier, taxtype, modifiers_into_modifier = false) {
    const modiferOption = new ModifierSetOptionBase({
      has_modifiers_into_modifier: modifiers_into_modifier,
      option_oadp: option.option_oadp,
      optionGuid: option.immo_guid,
      optionPkid: option.immo_pkid,
      option_pkid: option.immo_modifier_option_pkid,
      optionName: option.mm_items_modifier_options.modifier_option_name,
      imm_item_pkid: option.mm_items_modifier_options.imm_item_pkid
    });

    const { dinein_discount_price_value } = option;
    modiferOption.optionPrice = dinein_discount_price_value > 0 ? dinein_discount_price_value : option.mm_items_modifier_options.modifier_option_price;
    // if (this.serviceType === "COLLECTION") {
    //   modiferOption.optionPrice = collection_delivery_discount_price_value > 0 ? collection_delivery_discount_price_value : option_collection_price;
    // }
    modiferOption.optionPreSelected = option.immo_preselect;
    modiferOption.optionQuantity = 0;
    modiferOption.optionTaxRate = modifierTaxRate;
    modiferOption.optionTaxAmt = Number(modifierTax.toFixed(2));
    modiferOption.optionTaxGuid = option.mm_items_modifier_options.mm_taxes.tax_guid;
    modiferOption.optionSelected = option.immo_preselect;
    if (modiferOption.optionPreSelected) {
      modiferOption.optionQuantity = 1;
      modifier.quantity = modifier.quantity + 1;
      modifier.modifierSetSelected = true;
    }
    //option price discounted and actual 
    modiferOption.optionDineInPrice = option.option_dinein_price;
    modiferOption.optionDineInPriceDiscounted = option.option_dinein_price_discounted;
    modiferOption.optionCollectionPrice = option.option_collection_price;
    modiferOption.optionCollectionPriceDiscounted = option.option_collection_price_discounted;
    modiferOption.tax = option.mm_items_modifier_options.mm_taxes;
    // modiferOption.optionDeliveryPrice = option.option_delivery_price;
    // modiferOption.optionDeliveryPriceDiscounted = option.option_delivery_price_discounted;

    // no need to add the tax   

    return modiferOption;
  }

  setDefaults2(item, quantity?: number, modIds: number[] = []) {
    // set the variant selected from item picked
    // check if the lowest price item is sold out then pick the item within the stock
    item.quantity = quantity !== undefined ? quantity : 1;

    const activeVariant = item.variantList.length ? item.variantList[0] : null;
    if (activeVariant) {
      item.variantList[0].selected = true;
      item.variantList[0].variantQty = quantity !== undefined ? quantity : 1;
      item.priceEach = item.variantList[0].variantDineInPriceDiscounted ? item.variantList[0].variantDineInPriceDiscounted : item.variantList[0].variantDineInPrice;
      item.totalPrice = item.variantList[0].variantQty * item.priceEach;
      item.modifierSetList.forEach((modifier: ModifierSetBase) => {
        let modPrice = 0;
        let modId = [];
        modifier.modifierSetSelected = modifier.modifierOptions.some(x => modIds.includes(x.option_pkid))
        modifier.modifierOptions.forEach((option: ModifierSetOptionBase) => {

          if (option.optionPreSelected) {
            const price = option.optionDineInPriceDiscounted > 0 ? option.optionDineInPriceDiscounted : option.optionDineInPrice;
            item.priceEach = price;
          }

          if (modIds.includes(option.option_pkid)) {
            option.optionSelected = true;
            modPrice += (option.optionPrice * quantity);
            modId.push(option.option_pkid);
          }
        });
        if (modifier.modifierSetSelected) {
          debugger
          item.totalPrice = item.totalPrice + modPrice;
          const modId2 = modId.join('-');
          item.itemModId = `${item.itemGuid}-${item.iscvsd_pkid}-${modId}`;

        }
      });
    }

  }


  async fetchBasicSettings(tablePkid, locationPkid, companyPkid) {

    const url = `${EcomNetworkUtils.GET_BASIC_SETTINGS}`;
    let param = {}

    if (tablePkid) {
      param = {
        tableId: tablePkid
      }
    }
    else if (locationPkid && companyPkid) {
      param = {
        tableId: tablePkid,
        locationId: locationPkid,
        companyPkid: companyPkid
      }
    }

    const response = await this.ecomservice.httpPost(url, param, '', true).toPromise();
    if (response.isSuccess && response.listValue) {
      const data = response.listValue;
      data.serviceType = "DINE_IN";

      if (this.serviceType) {
        data.serviceType = this.serviceType;
      } else if (data.qrType === QRType.Store) {
        data.serviceType = data.store_qr_takeaway ? "COLLECTION" : "DINE_IN";
      }

      if (!this.settingService.getUserInfo()) this.settingService.setUserInfo(new User());
      this.settingService.setCompanySetting(data);


      const model = {
        oocls_location_pkid: data.oocls_location_pkid,
        oocls_company_id: data.oocls_company_id,
        companyPkid: data.oocls_company_pkid
      }


      const locationRes = await this.fetchLocationSetting(model);
      if (locationRes) {
        this.settingService.setLocationSetting(locationRes);
      }

      this.userServiceBase = this.settingService.getUserSerivce();
      const locationSelected = this.settingService.getLocationSetting();
      let adress = "";
      let serviceLocationName = "";

      if (locationSelected && locationSelected.mm_online_order_location_settings) {
        const lSetting = locationSelected.mm_online_order_location_settings;
        adress = lSetting.ools_location_address;
        serviceLocationName = lSetting.store_name;
      }
      this.storeServiceBase = new StoreServiceBase({
        serviceLocationAddress: adress,
        serviceLocationName: serviceLocationName,
        serviceType: this.serviceType,
        serviceStatus: 'OPEN',
        serviceLocationGuid: locationPkid,
        locationPkid: locationPkid,
        serviceLocationAreaId: "",
        serviceLocationTableId: tablePkid,
        serviceLocationTableName: data.tableName,
        serviceQRScanned: true,
        serviceCompanyId: locationSelected.company_id,
        serviceDatetime: this.getCurrentDateTime()
      });


      this.userServiceBase.selectedStoreServiceList = [];
      this.storeServiceBase.serviceActiveId = this.userServiceBase.selectedStoreServiceList.length + 1;
      this.webstorage.sessionSt_service_active_id = this.storeServiceBase.serviceActiveId;
      this.userServiceBase.selectedStoreServiceList.push(this.storeServiceBase);
      this.settingService.setUserSerivce(this.userServiceBase);
    }
  }

  async fetchLocationSetting(model) {
    const data = this.settingService.getLocationSetting();
    if (data) return data;
    const response = await this.ecomservice.httpPost(EcomNetworkUtils.POST_GET_LOCATIONS_SETTINGS, model, '', true).toPromise();
    if (response['status'] === 403) {
      this.router.navigate(['unauthorized']);
    } else {
      if (response.isSuccess) {
        this.ecomservice.loadingPage.loading = false;
        this.settingService.setLocationSetting(response.listValue);
        return response.listValue;

      }
    }
  }

  getCurrentDateTime() {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = now.getHours();
    const minutes = String(now.getMinutes()).padStart(2, '0');

    const ampm = hours >= 12 ? 'PM' : 'AM';
    const hour12 = hours % 12 || 12;

    return `${year}-${month}-${day} ${hour12}:${minutes} ${ampm}`;
  }

  setProgressBarPercentage(number: number, percentage: string) {
    this.statusWidthNumber = number;
    this.statusWidth = percentage;
  }


  // Method to update the status message
  updateStatusMessage(status) {
    // status message
    if (status === 'DRAFT') {
      this.statusMessage = 'your order is placed & waiting for restaurant to accept';
      this.orderStatus = 'Placed';
    } else if (status === 'SCHEDULED') {
      this.statusMessage = 'your order is confirmed & scheduled';
      this.orderStatus = 'Scheduled';
    } else if (status === 'INPROGRESS') {
      this.statusMessage = 'preparing your order';
      this.orderStatus = 'in progress';
    } else if (status === 'REJECT') {
      this.statusMessage = 'your order is rejected';
      this.orderStatus = 'Rejected';
    } else if (status === 'COMPLETE') {
      this.statusMessage = 'your order is completed';
      this.orderStatus = 'Completed';
    } else if (status === 'READY') {
      this.statusMessage = 'your order is ready';
      this.orderStatus = 'Ready';
    }
  }

  // Method to update the status width
  updateStatusWidth(remainingTimeInSeconds) {
    const pageurl = this.router.url;
    if (pageurl === '/status-dinein' || pageurl.includes('/status-dinein')) {
      const timeInMins = Number(Number(remainingTimeInSeconds / 60).toFixed(0));
      this.timeleft = (timeInMins < 10 ? '0' + timeInMins : timeInMins) + ' mins';
      // update for every 1 seconds
      remainingTimeInSeconds -= 1;
      this.statusWidthNumber = this.statusWidthNumber + this.percentageWidth;
      this.statusWidth = this.statusWidthNumber + '%';
      if (remainingTimeInSeconds > 0) {
        let temp = this;
        this.timeoutFunc = setTimeout(function () {
          temp.updateStatusWidth(remainingTimeInSeconds);
        }, 1000);
        return;
      }
    }
  }

  // Method to update the status end time
  setEndTime(kitchentime = 0) {
    // recalculate the end time
    if (kitchentime > 0) {
      let endTime = (this.progressEndTime.split(' ')[0]).split(':');
      let ampm = this.progressEndTime.split(' ')[1];
      let min: any = Number(endTime[1]) + kitchentime;
      let hour: any = Number(endTime[0])
      if (min >= 60) {
        hour = hour + 1;
        min = 60 - min;
      }
      min = min < 10 ? '0' + min : min;
      hour = hour < 10 ? '0' + hour : hour;
      let endtime = Number(hour) <= 12 ? (hour + ':' + min) : ((hour % 12) + ':' + min)
      this.progressEndTime = endtime + ' ' + ampm;
    } else {
      let endTime = (this.progressEndTime.split(' ')[0]).split(':');
      let ampm = this.progressEndTime.split(' ')[1];
      let min: any = Number(endTime[1]);
      let hour: any = Number(endTime[0])
      if (min >= 60) {
        hour = hour + 1;
        min = 60 - min;
      }
      min = min < 10 ? '0' + min : min;
      hour = hour < 10 ? '0' + hour : hour;
      let endtime = Number(hour) <= 12 ? (hour + ':' + min) : ((hour % 12) + ':' + min)
      this.progressEndTime = endtime + ' ' + ampm;
    }
  }

  // Method to handle the assistance click event
  async onAssistanceClick(template) {
    //document.location.href = 'tel:' + this.userSelectedStore.serviceLocationContact;
    // if it is table dine in then only send the notification
    var sound = new Howl({
      src: ['./assets/media/scanqr.mp3']
    });
    sound.play();
    this.modalRef = this.modalService.show(template, {
      animated: true,
      class: 'modal-dialog-centered modal-sm'
    });
    let temp = this;
    setTimeout(function () {
      temp.modalRef.hide();
      //$('.modal').css({"display": "none"});
    }, 10000);
    const response = await this.ecomservice.httpPost(EcomNetworkUtils.POST_ASSISTANCE_NOTIFY, this.statusinput, '', true).toPromise();
    if (response['status'] === 403) {
      this.router.navigate(['unauthorized']);
    } else {
      if (response.isSuccess) {

      }
    }

  }


  // Method to handle the view order click event
  onViewOrderClick() {
    this.router.navigate(['cart', this.webstorage.sessionSt_company_clicked]);
  }

  onPayNowClick() {

  }

  // Method to handle the view receipt click event
  onViewReceiptClick(template) {
    return
    this.modalRef = this.modalService.show(template, this.config);
    this.invoiceMsg = '';
  }

  // Method to handle the alert close event
  onClosed(dismissedAlert: AlertComponent): void {
    this.alerts = [];
  }


  onCloseModal(template) {
    this.modalRef.hide();
    //$('.modal').css({"display": "none"});
  }


  overlayOpen() {
    this.overlayDisplay = true;
  }

  closeOverlay() {
    this.overlayDisplay = false;
  }

  contactUsEventEmitter(event) {
    this.overlayDisplay = false;
  }

}
